import { render, staticRenderFns } from "./DescriptionCard.vue?vue&type=template&id=4a9eee5e&scoped=true"
import script from "./DescriptionCard.vue?vue&type=script&lang=js"
export * from "./DescriptionCard.vue?vue&type=script&lang=js"
import style0 from "./DescriptionCard.vue?vue&type=style&index=0&id=4a9eee5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9eee5e",
  null
  
)

export default component.exports